import { __assign, __rest } from "tslib";
import React from 'react';
import classNames from 'classnames';
export function BuyLink(_a) {
    var className = _a.className, style = _a.style, children = _a.children, weak = _a.weak, rest = __rest(_a, ["className", "style", "children", "weak"]);
    return (React.createElement("a", __assign({ className: classNames('buy-link', {
            'buy-link-weak': weak,
        }, className), style: style }, rest), children));
}
export function BuyWikiLink(_a) {
    var className = _a.className, style = _a.style, children = _a.children, rest = __rest(_a, ["className", "style", "children"]);
    return (React.createElement("a", __assign({ className: "buy-detail-note", style: style }, rest),
        React.createElement("i", { className: "buy-icon buy-icon-link" }),
        children));
}
export function BuyFormLink(_a) {
    var className = _a.className, style = _a.style, children = _a.children, _b = _a.right, right = _b === void 0 ? false : _b, rest = __rest(_a, ["className", "style", "children", "right"]);
    return (React.createElement("a", __assign({ className: classNames('buy-form__link', {
            'buy-form-separate__link': right,
        }, className), style: style }, rest), children));
}
//# sourceMappingURL=BuyLink.js.map